<template>
  <div class="step-container scrollPosition haus-step-7a">
    <div class="step-header">
      <h2 class="step-title">Zusatzflächen</h2>
      <p class="step-text">Mehrfachnennungen sind möglich.</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <SelectBox
          class="box-item small-icon-w-80"
          text="Balkon<br/>Wintergarten<br/>Terrasse"
          v-model="fields.flagBalkon.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7421.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7421_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-50"
          text="Keller"
          v-model="fields.flagKeller.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7420.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7420_white.svg')"
        />
        <SelectBox
          class="box-item small-icon-w-80"
          text="Nebengebäude"
          v-model="fields.flagNebengebaeude.value"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_7423.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_7423_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Constants from "@/constants.js";
import SelectBox from "@/components/shared/SelectBox.vue";
import {
  getFromStorage,
  saveToStorage,
  isSet,
  getFieldFromStorage,
} from "@/utils.js";
export default {
  name: "haus-step-7a",
  components: {
    SelectBox,
  },
  data() {
    return {
      fields: {
        flagBalkon: { value: "false" },
        flagKeller: { value: "false" },
        flagNebengebaeude: { value: "false" },
        hausBalkonM2: { value: null },
        hausKellerM2: { value: null },
        hausNebengebaeudeM2: { value: null },
      },
    };
  },
  methods: {
    isSet: isSet,
    goBack() {
      saveToStorage(this.fields);
      const ageOfProperty =
        new Date().getFullYear() - getFieldFromStorage("hausBaujahr");
      if (ageOfProperty >= Constants.NEW_BUILDING_THRESHOLD) {
        this.$router.push("/haus-step-6");
      } else {
        this.$router.push("/haus-step-4");
      }
    },
    goNext() {
      if (!isSet(this.fields.flagBalkon.value)) {
        this.fields.hausBalkonM2.value = null;
      }
      if (!isSet(this.fields.flagKeller.value)) {
        this.fields.hausKellerM2.value = null;
      }
      if (!isSet(this.fields.flagNebengebaeude.value)) {
        this.fields.hausNebengebaeudeM2.value = null;
      }
      saveToStorage(this.fields);
      if (
        isSet(this.fields.flagBalkon.value) ||
        isSet(this.fields.flagKeller.value) ||
        isSet(this.fields.flagNebengebaeude.value)
      ) {
        this.$router.push("/haus-step-7b");
      } else {
        this.$router.push("/haus-step-8");
      }
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 8);
    getFromStorage(this.fields);
  },
};
</script>
